import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import Paginator from '../../components/ui/Paginator';
import { ClassifierContext } from '../../context/classifier/ClassifierContext';
import { Classifier } from '../../models/interfaces';
import Message from '../../components/ui/Message';

export const ClassifiersPage = () => {

    const [buscar, setBuscar] = useState('');
    const [pageActual, setPageActual] = useState<number>(1);
    const [errorMessage, setErrorMessage] = useState('');
    const [confirmMessage, setConfirmMessage] = useState('');
    const [classifierId, setClassifierId] = useState(-1);



    const {
        classifiers,
        //totalPage,
        loadClassifiers,
        deleteClassifier,
        isLoading
    } = useContext(ClassifierContext);

    const navigate = useNavigate();

    useEffect(() => {
        loadClassifiers();
    }, [pageActual]);


    const filteredData = classifiers.filter(c =>
        c.name.toLowerCase().includes(buscar.toLowerCase()) ||
        c.code.toLowerCase().includes(buscar.toLowerCase())
    );


    const handleNew = () => {
        navigate('/classifier');
    };


    const handleEdit = (classifier: Classifier) => {
        navigate('/classifier', { state: { classifier } });
    };


    const handleValues = (classifier: Classifier) => {
        navigate('/classifier/values', { state: { classifier } });
    };


    const handleFis = (classifier: Classifier) => {
        navigate('/classifier/fis', { state: { classifier } });
    };


    const handleDelete = async (classifierId: number, classifierCode: string) => {
        setClassifierId(classifierId);
        setConfirmMessage("Confirma que desea eliminar el clasificador: " + classifierCode)
    };

    const removeError = () => {
        setErrorMessage('');
    }

    const removeConfirmMessage = () => setConfirmMessage('');

    const confirmDeleteClassifier = async () => {
        setConfirmMessage('');
        const resp = await deleteClassifier(classifierId);

        setClassifierId(-1);
        if (resp !== 'success') {
            setErrorMessage(resp);
        }
    }


    return (

        <div className="mt-5 container" style={styles.container}>


            {/* Buscador + Nuevo */}

            <div className="row justify-content-end mt-5">

                <div className="col-md-3">

                    <input
                        className="form-control"
                        type="text"
                        placeholder="Buscar"
                        value={buscar}
                        onChange={(e) => setBuscar(e.target.value)}
                    />

                </div>


                <div className="col-md-1">

                    <button
                        className="btn btn-success"
                        onClick={handleNew}
                    >
                        Nuevo
                    </button>

                </div>

            </div>


            <br />


            {/* Tabla */}

            <table className="table table-hover table-striped">

                <thead className="thead-dark">

                    <tr>

                        <th>Código</th>
                        <th>Nombre</th>
                        <th>Descripción</th>
                        {/* <th>Categoría</th> */}
                        {/* <th>Rol</th> */}
                        <th>Valor por defecto</th>

                        <th style={{ textAlign: 'center' }}>
                            Acciones
                        </th>

                    </tr>

                </thead>


                <tbody>

                    {
                        filteredData.length > 0
                            ?
                            filteredData.map(classifier => (
                                <tr key={classifier.classifierId}>
                                    <td>{classifier.code}</td>
                                    <td>{classifier.name}</td>
                                    <td>{classifier.description}</td>
                                    {/* <td>{classifier.category}</td> */}
                                    {/* <td>{classifier.role}</td> */}
                                    <td>
                                        {
                                            classifier.defaultValue
                                                ?
                                                classifier.defaultValue
                                                :
                                                "-"
                                        }
                                    </td>


                                    <td style={{ textAlign: 'center' }}>
                                        <div className="dropdown">
                                            <button
                                                className="btn btn-secondary dropdown-toggle"
                                                data-bs-toggle="dropdown"
                                            >
                                                <span className="bi bi-list"></span>
                                            </button>

                                            <ul className="dropdown-menu">
                                                <li>
                                                    <button
                                                        className="dropdown-item"
                                                        onClick={() => handleEdit(classifier)}
                                                    >
                                                        <i className="bi bi-pencil me-2"></i>
                                                        Editar
                                                    </button>
                                                </li>

                                                <li>

                                                    <button
                                                        className="dropdown-item"
                                                        onClick={() => handleValues(classifier)}
                                                    >

                                                        <i className="bi bi-card-list me-2"></i>

                                                        Valores

                                                    </button>

                                                </li>



                                                <li>

                                                    <button
                                                        className="dropdown-item"
                                                        onClick={() => handleFis(classifier)}
                                                    >

                                                        <i className="bi bi-bank me-2"></i>

                                                        Instituciones

                                                    </button>

                                                </li>



                                                <li>

                                                    <hr className="dropdown-divider" />

                                                </li>



                                                <li>

                                                    <button
                                                        className="dropdown-item text-danger"
                                                        onClick={() => handleDelete(classifier.classifierId, classifier.name)}
                                                    >

                                                        <i className="bi bi-trash me-2"></i>

                                                        Eliminar

                                                    </button>

                                                </li>


                                            </ul>


                                        </div>


                                    </td>


                                </tr>

                            ))

                            :

                            <tr>

                                <td colSpan={6} className="text-center">

                                    {
                                        isLoading
                                            ?
                                            "Cargando..."
                                            :
                                            "No existen clasificadores."
                                    }

                                </td>

                            </tr>

                    }


                </tbody>

            </table>



            {
                errorMessage.length > 0 &&

                <Message
                    type='error'
                    message={errorMessage}
                    closeDialog={removeError}
                    handleOk={removeError}
                    backgroundColor='rgba(0,0,0,0.4)'
                />
            }

            {confirmMessage &&
                <Message
                    type="success"
                    title="Confirmar"
                    message={confirmMessage}
                    closeDialog={removeConfirmMessage}
                    showCancel={true}
                    handleCancel={removeConfirmMessage}
                    handleOk={confirmDeleteClassifier}
                    okText="Confirmar"
                    backgroundColor="rgba(0,0,0,0.4)"
                />
            }


        </div>

    )

}



const styles = {

    container: {

        flex: 1,
        marginTop: 10,
        marginHorizontal: 20

    }

};